/**
 * RecordingApiError.
 *
 * @copyright Realeyes OU. All rights reserved.
 */


import ExtendableError from 'es6-error';


export default class RecordingApiError extends ExtendableError {}
